import { HttpClient, HttpMethods } from "@planzone/services";

function getPrivateDocuments(httpClient: HttpClient) {
  return (namespace: string, type: string) =>
    httpClient.sendHttpRequest<any>({
      endpoint: `/api/folder/${type}/${namespace}/criteriaFolder`,
      method: HttpMethods.POST,
    });
}

export { getPrivateDocuments };
